import React, {useState} from 'react'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {useForm} from 'react-hook-form'
import {ResourceListProps} from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem/ResourceList'
import {useAutoUpdateSidebarItem} from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem'
import {Rule} from 'Event/attendee-rules'
import Settings from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem/ResourceList/ResourceListConfig/Settings'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import ScheduleInput from 'organization/Event/DashboardConfig/ComponentConfigPanel/ScheduleInput'
import Styling from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem/ResourceList/ResourceListConfig/Styling'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {useAddTranslation} from 'Event/LanguageProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'

export function ResourceListConfig(
  props: ComponentConfigProps & {
    id: string
    list: ResourceListProps
  },
) {
  const {showing, onClose, list, id} = props
  const {
    handleSubmit,
    control,
    register,
    watch,
    setValue,
    formState,
  } = useForm()
  const [rules, setRules] = useState<Rule[]>(list.rules || [])
  const addTranslation = useAddTranslation()
  const saveTemplate = useSaveTemplate()

  const save = (data: Pick<ResourceListProps, 'title' | 'description'>) => {
    const title = replaceAtPath(data, 'title', `{{${id}_title}}`)
    const description = replaceAtPath(
      data,
      'description',
      `{{${id}_description}}`,
    )

    saveTemplate({
      sidebarItems: {
        [id]: {...data, rules},
      },
      localization: addTranslation({
        [`${id}_title`]: title ?? '',
        [`${id}_description`]: description ?? '',
      }),
    })

    onClose()
  }

  useAutoUpdateSidebarItem({item: watch(), when: showing})

  return (
    <ComponentConfig
      showing={showing}
      onClose={onClose}
      title="Resources"
      onSubmit={handleSubmit(save)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} list={list} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} list={list} />
      </StylingPanel>
      <RulesPanel rules={rules} setRules={setRules}>
        <ScheduleInput setValue={setValue} control={control} values={list} />
      </RulesPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
